export interface EmailFilterPayload {
  senders?: string[]
  before?: string
  after?: string
  filter?: EmailMetadataFilter
}

export interface EmailFilter {
  id: string
  name: string
  isDefault: boolean
  filter: EmailFilterPayload
  type: 'user' | 'system'
}

export enum EmailFilterOperator {
  GT = '>',
  LT = '<',
  EQUALS = '=',
  NOT_EQUALS = '!=',
  GTE = '>=',
  LTE = '<=',
  IN = 'IN',
  NOT_IN = 'NOT IN',
}

export type EmailMetadataFilterAttribute = 'new' | 'replyGenerated' | 'processed' | 'emailType'

export type EmailMetadataFilter = IndividualEmailMetadataFilter | CompositeEmailMetadataFilter
export interface IndividualEmailMetadataFilterValue {
  op: EmailFilterOperator
  attr: EmailMetadataFilterAttribute
  val: string | boolean
}

export interface IndividualEmailMetadataFilter {
  type: 'individual'
  filter: IndividualEmailMetadataFilterValue
}

export interface CompositeEmailMetadataFilter {
  type: 'composite'
  filters: EmailMetadataFilter[]
  operator: 'and' | 'or'
}
